import { http } from 'utils'

import { DATASTATUS } from 'constants/status'

import {
  FileCreateFormTypes,
  FileTypesAPISchemas,
  FileTypesAPITypes,
  FilesAPISchemas,
  FilesAPITypes,
} from "schemas/files"

export const postDownloadFile = async (payload: FileCreateFormTypes) => {
  const url = `/thorFiles/download`

  const response = await http.post(url, payload, {
    responseType: 'blob',
  })

  const disposition = response.headers['content-disposition']
  const contentType = response.headers['content-type']

  const fileNameMatch = disposition?.match(/filename="?(.+?)"?$/)
  const fileName = fileNameMatch?.[1] ?? payload.fileName ?? 'download'

  const blob = new Blob([response.data], { type: contentType })

  const urlBlob = window.URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = urlBlob
  a.download = fileName
  a.click()

  window.URL.revokeObjectURL(urlBlob)

  return true
}

export async function getFileTypes(): Promise<FileTypesAPITypes> {
  let url = `/thorFiles/types`
  const params = new URLSearchParams()

  url += `?${params.toString()}`

  const response = await http.get<unknown>(url)
  const validatedData = FileTypesAPISchemas.safeParse(
    response.data
  )
  if (!validatedData.success) {
    return {
      fileTypes: [],
      outcomeMessage: JSON.stringify(validatedData.error),
      ...DATASTATUS,
    }
  }
  return validatedData.data
}

export async function getFilesAPI(fileTypeId?: number): Promise<FilesAPITypes> {
  let url = `/thorFiles`
  const params = new URLSearchParams()

  if (fileTypeId != null) {
    params.append('fileTypeId', String(fileTypeId))
  }

  url += `?${params.toString()}`

  const response = await http.get<unknown>(url)
  const validatedData = FilesAPISchemas.safeParse(
    response.data
  )
  if (!validatedData.success) {
    return {
      files: [],
      outcomeMessage: JSON.stringify(validatedData.error),
      ...DATASTATUS,
    }
  }
  return validatedData.data
}
